<template>
<div class="chapter">
<div class="inner_page">
<p class="C1613"><span id="page_5">It’s </span>Hard to Know Where to Begin</p>
<p class="C1600">I could start under a tree outside</p>
<p class="C1600">my grandmother’s kitchen window,</p>
<p class="C1600">or I could wait until the dog needs</p>
<p class="C1600">a walk, or I could start over here</p>
<p class="C1600">by the couch and stack of books.</p>
<p class="C1600">Maybe not; maybe upstairs under</p>
<p class="C1600">the bed or even in the basement,</p>
<p class="C1600">back behind that pile of toys we</p>
<p class="C1600">keep saying we’ll give away.</p>
<p class="C1600">The garden is a possibility,</p>
<p class="C1600">around the comfrey or the spent</p>
<p class="C1600">peonies. Or maybe just here,</p>
<p class="C1600">where an old man from when</p>
<p class="C1600">I was a kid came up and asked</p>
<p class="C1600">if I would look at his hands.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_It_s_Har.vue?8aa79650